/* eslint-disable linebreak-style */
import Vue from 'vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, Axios);
Axios.defaults.baseURL = (window.location.hostname === 'localhost') ? 'http://localhost:3030' : process.env.VUE_APP_PRODUCTION_HOST;
Axios.defaults.headers.common.Authorization = `Bearer ${(window.sessionStorage.getItem('auth-key') || window.localStorage.getItem('auth-key'))}`;
Axios.defaults.headers.post['Content-Type'] = 'application/json';

export default Axios;
